import React from "react";
import routes from "src/core/common/routes";
import MyAccount from "src/core/user/components/MyAccount";
import ChangePassword from "src/core/user/components/ChangePassword";
import PersonalInfo from "src/core/user/components/PersonalInfo";
import OrdersBrowser from "src/core/user/components/OrdersBrowser";
import PaymentMethodsModal from "src/core/user/components/PaymentMethodsModal";
import CardPaymentMethodsModal from "src/core/user/components/CardPaymentMethodsModal";
import OrderTipWrapper from "src/core/user/components/OrderTip";
import OrderRatingWrapper from "src/core/user/components/OrderRating";
import BillingAddressModal from "src/core/user/components/BillingAddressModal";
import Route from "src/core/common/components/modules/Route";
import DeliveryModal from "src/core/deliveries/components/DeliveryModal";
import useRouter from "src/core/common/hooks/useRouter";
import DeactivateAccountModal from "src/core/user/components/DeactivateAccountModal";
import {IdentityVerificationModalWrapper} from "src/integrations/identityVerification/components/IdentityVerificationContext";
import IdentityVerificationModal from "src/integrations/identityVerification/components/IdentityVerificationModal";

export default function UserPage({onRequestClose}) {
  const router = useRouter();
  return (
    <IdentityVerificationModalWrapper>
      <Route
        path={routes.myAccount}
        Component={MyAccount}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.changePassword}
        Component={ChangePassword}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.personalInfo}
        Component={PersonalInfo}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.userOrders}
        Component={OrdersBrowser}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.accountCreditCards}
        Component={CardPaymentMethodsModal}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.paymentMethods}
        Component={PaymentMethodsModal}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.userOrderTip}
        Component={OrderTipWrapper}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.userOrderRating}
        Component={OrderRatingWrapper}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.accountBillingAddress}
        Component={BillingAddressModal}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.accountDeliveryCheck}
        Component={DeliveryModal}
        componentProps={{
          onSuccess: router.safeBack,
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.deactivateAccount}
        Component={DeactivateAccountModal}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.identityVerification}
        Component={IdentityVerificationModal}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
    </IdentityVerificationModalWrapper>
  );
}
